import { render, staticRenderFns } from "./volunteerTable.vue?vue&type=template&id=521ab96d&scoped=true"
import script from "./volunteerTable.vue?vue&type=script&lang=js"
export * from "./volunteerTable.vue?vue&type=script&lang=js"
import style0 from "./volunteerTable.vue?vue&type=style&index=0&id=521ab96d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ab96d",
  null
  
)

export default component.exports